import React from "react";
import AcedModal from "../../../../components/essentials/modals/aced-modal/AcedModal";
import "./WritePostBar.scss";

// import { ReactComponent as Clips } from "../../../../assets/images/Clips.svg";
// import { ReactComponent as LilImage } from "../../../../assets/images/Image.svg";
// import { ReactComponent as Send } from "../../../../assets/images/Send.svg";
// import { ReactComponent as Video } from "../../../../assets/images/Video.svg";
import Button from "../../../../components/essentials/button/Button";
import CreatePost from "../../post/create-post/CreatePost";

export interface WritePostBarProps {
  onCreatePost: any;
  createPostModalState: {
    isCreatePostModalOpen: any;
    setCreatePostModal: any;
  };
}
const WritePostBar: React.FC<WritePostBarProps> = ({
  createPostModalState,
  onCreatePost,
}) => {
  return (
    <>
      <div className="write-post">
        <Button
          className="btn btn-primary"
          action={() => createPostModalState.setCreatePostModal(true)}
        >
          Write Post
        </Button>
        <div className="write-post__divider"></div>

        {/* <div className="write-post__menu">
          <div className="d-flex justify-space-between write-post__menu-subset">
            <LilImage className="write-post__menu-button" />

            <Video className="write-post__menu-button" />

            <Clips className="write-post__menu-button" />
          </div>

          <Send className="write-post__menu-button" />
        </div> */}
      </div>
      <AcedModal
        state={{
          isModalOpen: createPostModalState.isCreatePostModalOpen,
          setModalOpen: createPostModalState.setCreatePostModal,
        }}
      >
        <CreatePost
          closeModal={() => createPostModalState.setCreatePostModal(false)}
          onCreatePost={onCreatePost}
        />
      </AcedModal>
    </>
    // <View style={styles.container}>

    //   <View style={styles.menu}>
    //     <Pressable style={[styles.button, globalStylesheet.center]}>
    //       {getSvgImage("LilImage", { width: 23, height: 23 })}
    //     </Pressable>
    //     <Pressable style={[styles.button, globalStylesheet.center]}>
    //       {getSvgImage("Video", { width: 29.4 })}
    //     </Pressable>
    //     <Pressable style={[styles.button, globalStylesheet.center]}>
    //       {getSvgImage("Clips", { width: 19.5 })}
    //     </Pressable>
    //     <View style={{ flex: 1 }}></View>
    //     <Pressable style={[styles.button, globalStylesheet.center]}>
    //       {getSvgImage(
    //         "Send",
    //         { width: 21, height: 21 },
    //         colorPalette.baseBlack
    //       )}
    //     </Pressable>
    //   </View>
    // </View>
  );
};

// const styles = StyleSheet.create({

//   menu: {
//     marginTop: 21.5,
//     height: 53,
//     padding: 10,
//     borderRadius: 8,
//     backgroundColor: colorPalette.darkGray3,
//     flexDirection: "row",
//     alignItems: "center",
//     justifyContent: "space-between",
//   },

//   button: {
//     height: 38,
//     width: 38,
//     flex: 1,
//   },
// });

export default WritePostBar;
